var map = {
	"./button.wav": 130,
	"./celebration.wav": 231,
	"./clear_piano.wav": 232,
	"./correct_answer_1.mp3": 233,
	"./incorrect_answer_1.mp3": 234,
	"./incorrect_in_print.wav": 235,
	"./print_correct.wav": 236,
	"./tap_01.wav": 85,
	"./tap_02.wav": 86,
	"./tap_03.wav": 87,
	"./tap_04.wav": 88,
	"./tap_05.wav": 89
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 417;